export const USER_ONBOARDING_STEPS = [
  '/app/ai_notetaker_wizard',
  '/app/ai_notetaker_wizard/recording_rules'
]


export const INITIAL_PAGE_SIZE = 100
export const PAGE_SIZE = 10

export const VALID_MI_CALENDARS = ['google']

export const USER_HAS_MEETING_ROUTE = '/app/meetings/user/me'

export const MI_MEETINGS_TOUR = {
  STEP_ONE: 'see_meetings',
  STEP_TWO: 'find_meetings',
  STEP_THREE: 'control_meetings',
}

export const MEETING_RECAP_TOUR = {
  STEP_ONE: 'recap_step_one',
  STEP_TWO: 'recap_step_two',
  STEP_THREE: 'recap_step_three',
}

export const MR_ONBOARDING_WIZARD = {
  ACKNOWLEDGEMENT: 'acknowledgement',
  RECORDING_RULES: 'recording_rules',
  RECORDING_RULES_AUTO_LOAD: 'auto_recording_rules',
  FREE_MAIL: 'mail_type',
  AUTO_LOAD: 'autoload',
  LOADING: 'loading',
  USER_TRIGGERED: 'user_triggered'
}

export const WIZARD_MODAL_SEEN_MAX = 3
export const SESSION_KEY = 'mi_onboarding_wizard_session_shown'
export const AUTO_SHARE_DISCOVERY_SESSION_KEY = 'auto_share_discovery_modal_session_shown'

export const WIZARD_LOADER_TIMER_LENGTH = 2000

// Include Teams only if the flag is enabled
const VIDEO_LOCATION_KINDS = ['ZOOM', 'GOOGLE_MEET']
const VIDEO_LOCATION_TYPES = ['zoom_conference', 'google_conference']
export const getVideoLocationKinds = (hasMsTeamsFlag = false) => {
  const kinds = [...VIDEO_LOCATION_KINDS]
  if (hasMsTeamsFlag) {
    kinds.push('MICROSOFT_TEAMS')
  }
  return kinds
}

/** Integrations that appear in recording rules but have no push-recaps toggle (connection only). */
export const INTEGRATION_WITHOUT_TOGGLE = ['zapier']

/** All integrations supported in recording rules (with or without toggle). */
export const ALL_RECORDING_RULES_INTEGRATIONS = ['hubspot', 'salesforce', ...INTEGRATION_WITHOUT_TOGGLE]

export const getVideoLocationTypes = (hasMsTeamsFlag = false) => {
  const types = [...VIDEO_LOCATION_TYPES]
  if (hasMsTeamsFlag) {
    types.push('microsoft_teams_conference')
  }
  return types
}

// Layout breakpoints
export const NARROW_VIEW_BREAKPOINT = 965
export const SPOTLIGHT_FORCED_NARROW_VIEW_BREAKPOINT = 1380

export const ONBOARDING_VIDEO_ID = '6ephc3ayz2'
